<template>
    <v-row>
        <v-col cols="12">
            <div class="d-flex align-center justify-space-between">
                <div class="d-flex d-inline flex-grow-1 align-center">
                    <div class="d-inline sansation_headline" v-html="text"></div>
                    <v-divider vertical class="mx-4" color="#DDD"></v-divider>
                    <div class="d-inline sansation_light">{{ questionCount }} question{{questionCount == 1 ? '' : 's'}}</div>
                </div>

                <div v-if="moduleKey == 'buyer' && tabKey == 'uploads'" 
                    class="d-inline flex-grow-1 sansation_light text-right justify-end"
                    style="max-width:50%">
                    <v-icon small class="mt-n1 mr-3" color="warning">mdi-asterisk-circle-outline</v-icon>
                    Uploading documents is not required, but is strongly encouraged. This information may become more relevant in the future. You may still express interest on listings if not provided.
                </div>
                
                <div v-if="['employment-resources-premium', 'employment-resources-elite'].includes(moduleKey) && tabKey == 'upload-requirements'" 
                    class="d-inline flex-grow-1 sansation_light text-right justify-end"
                    style="max-width:50%">
                    <v-icon small class="mt-n1 mr-3" color="warning">mdi-asterisk-circle-outline</v-icon>
                    Please upload any of the documents requested below if applicable.
                </div>
                
                <div v-if="['merger-premium', 'merger-elite'].includes(moduleKey) &&  !['merger-parties','nm-ensemble-info'].includes(tabKey)" 
                    class="d-inline flex-grow-1 sansation_light text-right justify-end"
                    style="max-width:50%">
                    <v-icon small class="mt-n1 mr-3" color="warning">mdi-asterisk-circle-outline</v-icon>
                    Please provide any available information regarding the company after the merger.
                </div>

            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'SectionHeader',
        props: {
            text: String,
            questionCount: Number,
            tabKey: String,
            moduleKey: String
            // order: String
        },
        // created() {
        //     this.$emit('saveValues');
        // }
    }
</script>


// WEBPACK FOOTER //
// src/components/questionnaire_template/section-header.vue